// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsTensileRelaxSample_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9 20.9708V32H7L7 22L0 17V5L7 0H13L20 5V14L18 14V6.02924L12.3591 2H7.64093L2 6.02924V15.9708L9 20.9708Z" class="svg-bg"/>
  <path d="M32 16 11 16V18H32V16ZM11 30H32V32H11V30Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0007 19.3408C14.56 20.3243 17.7806 20.9995 21.5007 20.9995C25.2213 20.9995 28.4424 20.3241 30.0014 19.3403L30.0007 28.6597C28.4414 27.6762 25.2208 27.001 21.5007 27.001C17.7801 27.001 14.559 27.6764 13 28.6602L13.0007 19.3408ZM15.0007 22.3567C16.7885 22.7599 19.0463 23.0005 21.5007 23.0005C23.9551 23.0005 26.2128 22.7599 28.0007 22.3567V25.6438C26.2128 25.2406 23.9551 25 21.5007 25C19.0463 25 16.7885 25.2406 15.0007 25.6438V22.3567Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsTensileRelaxSample is a generated icon component.
 */
let IconRmsTensileRelaxSample = IconRmsTensileRelaxSample_1 = class IconRmsTensileRelaxSample extends IconBaseElement {
    render() {
        return html `${IconRmsTensileRelaxSample_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsTensileRelaxSample.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsTensileRelaxSample = IconRmsTensileRelaxSample_1 = __decorate([
    customElement('zui-icon-rms-tensile-relax-sample')
], IconRmsTensileRelaxSample);
export { IconRmsTensileRelaxSample };
